import { ElementType } from "react";
import { Chip, alpha } from "@mui/material";
import { Article, AutoAwesome, UploadFile } from "@mui/icons-material";
import { teal } from "@mui/material/colors";
import { makeStyles, useTheme } from "@/compat/muiStyles";

const useStyles = makeStyles((theme) => ({
  group: {
    alignItems: "center",
    display: "inline-flex",
    gap: theme.spacing(0.75),
  },
  chip: {
    fontWeight: 600,
    "& .MuiChip-icon": { color: "inherit" },
  },
}));

type Entry = { label: string; Icon: ElementType; color: string };

// An AI-written template carries both badges: the AI marker qualifies Template, not replaces it.
export default function RiskAssessmentSourceBadge({
  isUploaded,
  isAiGenerated,
}: {
  isUploaded?: boolean;
  isAiGenerated?: boolean;
}) {
  const classes = useStyles();
  const theme = useTheme();

  const entries: Entry[] = isUploaded
    ? [{ label: "Uploaded", Icon: UploadFile, color: theme.palette.secondary.main }]
    : [{ label: "Template", Icon: Article, color: teal[600] }];

  // An uploaded document is never AI-written, so the marker only applies to templates.
  if (isAiGenerated && !isUploaded) {
    entries.unshift({ label: "AI", Icon: AutoAwesome, color: theme.palette.secondary.main });
  }

  return (
    <span className={classes.group}>
      {entries.map(({ label, Icon, color }) => (
        <Chip
          key={label}
          size="small"
          variant="outlined"
          className={classes.chip}
          icon={<Icon fontSize="small" />}
          label={label}
          style={{ color, borderColor: alpha(color, 0.5) }}
        />
      ))}
    </span>
  );
}
